<template>
  <div class="level">
    <qd-collapse class="column is-5 is-paddingless" >
      <div class="columns is-multiline is-marginless subMenu">
        <div class="column is-12 is-paddingless">
          <div class="level-right">
            <button @click="close()" class="button is-subMenu">
              <b-icon icon="close"
                      custom-size="mdi-10px"
                      type="is-white">
              </b-icon>
            </button>
          </div>
          <display-menu-and-sub-menu :menuAndSubMenu="achatMenu">
          </display-menu-and-sub-menu>
        </div>
      </div>
    </qd-collapse>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import displayMenuAndSubMenu from '@/components/sideBar/submenuSidebar/displayMenuAndSubMenu';
import { SET_ACHAT_MENU } from '@/store/modules/menu/menu-mutation-type';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import * as permissions from '@/configuration/achat/permissionsConf';
import { FOURNISSEUR_SUPPORT } from '@/configuration/presse/permissionsPresseConf';
import {
  MENU_FOURNISSEUR_SUPPORT,
  MENU_MARCHE,
  MENU_LIEU_LIVRAISON,
  MENU_FOURNISSEURS,
  MENU_ACHAT,
  MENU_COMMANDES,
  MENU_LIGNE_COMMANDE_ACHAT,
  MENU_BON_RECEPTION,
  MENU_FACTURES,
  MENU_PAIEMENTS_FACTURES,
  MENU_JOURNAL_PAIEMENTS_FACTURES,
  MENU_LOT_PAIEMENT_FACTURES,
  MENU_SUIVI_ACHATS,
} from '@/configuration/bodac/menuAchat';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';

const menu = createNamespacedHelpers('menu');
const Parametres = createNamespacedHelpers('parametres');

export default {
  components: {
    displayMenuAndSubMenu,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleAchatActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleAchat.key);
    },
    moduleMarcheActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleMarche.key);
    },
    moduleFounisseurSupportActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleFournisseurSupport.key);
    },
    achatMenu() {
      const menu = [
        {
          title: MENU_FOURNISSEURS,
          noSubMenu: false,
          data: [
            { name: MENU_FOURNISSEURS, path: 'l.achat.fournisseurs', perm: permissions.FOURNISSEURS.lecture },
          ],
        },
        {
          title: 'sidebar.achat.produits',
          path: 'l.bodac.catalogue-produitAchat',
          noSubMenu: true,
          perm: CATALOGUE.lecture,
        },
        {
          title: MENU_LIEU_LIVRAISON,
          path: 'l.achat.lieu_de_livraison',
          noSubMenu: true,
          perm: permissions.LIEU_DE_LIVRAISON.lecture,
        },
      ];
      if (this.moduleMarcheActive) {
        menu.push({
          title: MENU_MARCHE,
          path: 'l.presse.marche',
          noSubMenu: true,
          perm: permissions.MARCHE.lecture,
        });
      }
      if (this.moduleFounisseurSupportActive) {
        menu.push({
          title: MENU_FOURNISSEUR_SUPPORT,
          path: 'l.presse.fournisseur_support',
          noSubMenu: true,
          perm: FOURNISSEUR_SUPPORT.lecture,
        });
      }
      if (this.moduleAchatActive) {
        menu.unshift({
          title: MENU_ACHAT,
          noSubMenu: false,
          data: [
            { name: MENU_COMMANDES, path: 'l.achat.commandes', perm: permissions.COMMANDES.lecture },
            { name: MENU_LIGNE_COMMANDE_ACHAT, path: 'l.achat.commandes-ligne_commande_achat', perm: permissions.COMMANDES.lecture },
            { name: MENU_BON_RECEPTION, path: 'l.achat.bon_reception', perm: permissions.BON_RECEPTION.lecture },
            { name: MENU_FACTURES, path: 'l.achat.factures', perm: permissions.FACTURES.lecture },
            { name: MENU_PAIEMENTS_FACTURES, path: 'l.achat.paiements_factures', perm: permissions.PAIEMENTS_FACTURES.lecture },
            { name: MENU_LOT_PAIEMENT_FACTURES, path: 'l.achat.lot_paiements_factures', perm: permissions.LOT_PAIEMENTS_FACTURES.lecture },
            { name: MENU_JOURNAL_PAIEMENTS_FACTURES, path: 'l.achat.journal_paiements_factures', perm: permissions.JOURNAL_PAIEMENTS_FACTURES.lecture },
            { name: MENU_SUIVI_ACHATS, path: 'l.achat.suivi_taches_internes', perm: permissions.SUIVI_TACHES_INTERNES.lecture },
          ],
        });
      }
      return menu;
    },
  },
  methods: {
    ...menu.mapMutations({
      setAchatMenu: SET_ACHAT_MENU,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    close() {
      this.setAchatMenu(false);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleFournisseurSupport.key,
        PARAMETRES_INTERNE_KEYS.moduleMarche.key,
        PARAMETRES_INTERNE_KEYS.moduleAchat.key,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
